import { Client } from '@api/index'
import { PaymentPayload } from '@utils/types'

const token = () => `v3/oauth/token`
const getFooter = () => `gcms-svc/public/pages/pw-layout`
const updateUserDetails = () => `v1/users`
const verifyOtp = () => `v1/users/verify-otp`
const verifyEmailUrl = () => `v1/users/verify-email`
const getEmailOtpUrl = () => `v1/users/get-email-otp`
const getFAQS = (catId: string) => `v1/faq-category/${catId}/list`
const getUploadFile = () => 'v1/student-acquisition/ambassador-client/upload'
const resendOTP = (smsType: number) => `v1/users/resend-otp?smsType=${smsType}`
const generatorCoupon = () => `v1/student-acquisition/ambassador-client/coupon`
const getRegisterOTP = (smsType: number) =>
  `v3/users/get-otp-register?smsType=${smsType}`
const getOTP = (smsType: number) => `v1/users/get-otp?smsType=${smsType}`
const getMyProfileDetails = () =>
  'v1/student-acquisition/ambassador-client/my-profile'
const getCreateApplication = () =>
  `v1/student-acquisition/ambassador-client/create-application`
const getBankDetails = (ifsc: string) =>
  `v1/student-acquisition/ambassador-client/bank/${ifsc}`
const getSignedUrl = (key: string) =>
  `v1/student-acquisition/ambassador-client/get-signKey?key=${key}`

const getReportData = () => `v1/student-acquisition/performance-report`
const getStatsData = () => 'v1/student-acquisition/performance-report/stats'
const getCommissionDetails = () =>
  `v1/student-acquisition/ambassador/commission-structure`

const getEarningLevel = () => `v1/student-acquisition/ambassador/earning-levels`

const getList = () => `v1/student-acquisition/public/location-directory`
const getTransactionHistory = () => `v1/student-acquisition/ambassador-payouts`

const getGraphAnalytics = () =>
  `v1/student-acquisition/performance-report/analytics`

const ambassadorOperators = () =>
  `/v1/student-acquisition/ambassador-client/ambassador-operators`

const commissionNotification = () =>
  `v1/student-acquisition/ambassador/commission-structure/updated-date`
const loactionNotification = () =>
  `v1/student-acquisition/ambassador-client/update-lat-long`

const GET_COHORT_BATCHES = (cohortId: string, userId: string) =>
  `v1/student-acquisition/ambassador-client/${cohortId}/batches/${userId}`

const GET_SEARCH_BATCHES = (userId: string) =>
  `v1/student-acquisition/ambassador-client/${userId}/search-batches`

const getBatchLanguage = (batchId: string) =>
  `v3/batch-service/batch-config/${batchId}/languages`

const ENROLL_BATCH = (batchId: string) => `v1/batches/${batchId}/enroll-student`

const NOTIFY_USERS = `v3/` + `batches/user-notify`
const getComparePlansUrl = (batchId: string, userId: string) =>
  `v1/student-acquisition/ambassador-client/${batchId}/compare-plans/${userId}`

const getUpgradeBannerSnoozeUrl = (batchId: string) =>
  `batch-service/v1/batch-config/${batchId}/upgrade-banner/snooze`
const getMahapackDemoVideoUrl = `v1/demo-videos`

const getOrderDetailsUrl = (orderId: string, userId: string) =>
  `v1/student-acquisition/ambassador-client/${orderId}/order-info/${userId}`

const getFaqUrl = (faqCatId: string) => `v1/faq-category/${faqCatId}/list`

const getInvoiceDetailUrl = (orderId: string, userId: string) =>
  `v1/student-acquisition/ambassador-client/${orderId}/order-invoice/${userId}`

const getVpCenterList = () => `v1/student-acquisition/leads/vp-centers`
const uploadMapping = () => `v1/student-acquisition/leads/upload`
const getBulkUploadedStatus = (id: string) =>
  `v1/student-acquisition/payouts-upload-history/${id}`

const getDownloadFileLink = (key: string) =>
  `v1/student-acquisition/ambassador-client/get-signKey?key=${key}`
const leadDetails = () => `v1/student-acquisition/leads`

const leadsCountDetails = () => `v1/student-acquisition/leads/count`
const getSaathiAnalytics = () => `v1/student-acquisition/leads/leads-payout`

const updatePaymentDetails = () =>
  'v1/student-acquisition/ambassador-client/update-application-request'
const reviewStatusDetails = () =>
  `v1/student-acquisition/ambassador-client/application-request-status`

const vleToken = () => `v3/oauth/public/vle-token`

const taskAlocatorOtp = () =>
  `v1/student-acquisition/ambassador-client/ambassador-tasks/view-task-otp`

// Fetcher
export const faqsFetcher = ({ queryKey }: any) => {
  const { faqCatId, organizationId } = queryKey[1]
  const params = {
    organizationId: organizationId,
  }
  return Client.get(getFAQS(faqCatId), { params })
}

export const footerFetcher = () => {
  return Client.get(getFooter())
}

export const OTPRegisterFetcher = (data: any) => {
  const smsType = data?.smsType
  const payload = {
    username: data?.username,
    countryCode: data?.countryCode,
    organizationId: data?.organizationId,
    otpDigits: 6,
    firstName: data?.firstName,
    lastName: data?.lastName,
  }
  return Client.post(getRegisterOTP(smsType), payload)
}

export const verifyOtpFetcher = (data: any) => {
  const { ...payload } = data
  return Client.post(verifyOtp(), { ...payload })
}

export const tokenFetcher = async (data: any) => {
  const { ...payload } = data
  return Client.post(await token(), { ...payload })
}

export const vleTokenFetcher = async (data: any) => {
  const { ...payload } = data
  return Client.post(vleToken(), { ...payload })
}

export const resendOTPFetcher = (data: any) => {
  const smsType = data?.smsType
  const payload = {
    mobile: data?.username,
    organizationId: data?.organizationId,
  }
  return Client.post(resendOTP(smsType), { ...payload })
}

export const createApplicationFetcher = (data: any) => {
  return Client.post(getCreateApplication(), data)
}

export const getProfileRegisterFetcher = (data: any) => {
  return Client.put(getMyProfileDetails(), data)
}

export const getEmailOtpFetcher = (data: any) => {
  return Client.post(getEmailOtpUrl(), data)
}

export const verifyEmailFetcher = (data: any) => {
  return Client.post(verifyEmailUrl(), data)
}

export const updateUserDetailsFetcher = (data: any) => {
  return Client.put(updateUserDetails(), data)
}

export const myProfileFetcher = (data: any) => {
  return Client.put(getMyProfileDetails(), data)
}

export const profileDetailsFetcher = () => {
  return Client.get(getMyProfileDetails())
}

export const paymentDetailsFetcher = (data: any) => {
  return Client.put(getMyProfileDetails(), data)
}

export const uploadFileFetcher = (data: any) => {
  return Client.post(getUploadFile(), data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const signedUrlFetcher = (key: string) => {
  return Client.get(getSignedUrl(key))
}

export const bankDetailsFetcher = ({ queryKey }: any) => {
  const { ifsc } = queryKey[1]
  return Client.get(getBankDetails(ifsc))
}

export const generatorCouponFetcher = () => {
  return Client.post(generatorCoupon())
}

export const reportDataFetcher = ({ queryKey }: any) => {
  const { startDate, endDate } = queryKey[1]
  const params = {
    startDate,
    endDate,
  }
  return Client.get(getReportData(), { params })
}

export const stateFetcher = (data: any) => {
  const { name } = data
  const params = {
    name,
    type: 'STATE',
  }
  return Client.get(getList(), { params })
}

export const CityFetcher = (data: any) => {
  const { name } = data
  const params = {
    name,
    type: 'CITY',
  }
  return Client.get(getList(), { params })
}

export const CollegeFetcher = (data: any) => {
  const { name } = data
  const params = {
    name,
    type: 'COLLEGE',
  }
  return Client.get(getList(), { params })
}

export const commissionDetailsFetchter = ({ queryKey }: any) => {
  const { program, orgFeatType } = queryKey[1]
  const params = {
    program,
    orgFeatType,
  }
  return Client.get(getCommissionDetails(), { params })
}

export const earningLevelFetchter = ({ queryKey }: any) => {
  const { program } = queryKey[1]
  const params = {
    program,
  }
  return Client.get(getEarningLevel(), { params })
}

export const performanceReportStatsFetcher = async () => {
  return Client.get(getStatsData())
}

export const getTransactionHistoryFetcher = async () => {
  return Client.get(getTransactionHistory())
}

export const getGraphAnalyticsFetcher = ({ queryKey }: any) => {
  const { startDate, endDate, applyYearlyMetrics } = queryKey[1]
  const params = {
    startDate: startDate,
    endDate: endDate,
    applyYearlyMetrics: applyYearlyMetrics,
  }
  return Client.get(getGraphAnalytics(), { params })
}

export const getAmbassadorOperatorsFetcher = async () => {
  return Client.get(ambassadorOperators())
}

export const OTPFetcher = (data: any) => {
  const smsType = data?.smsType
  const payload = {
    username: data?.username,
    countryCode: data?.countryCode,
    organizationId: data?.organizationId,
    otpDigits: 6,
  }
  return Client.post(getOTP(smsType), payload)
}

export const commissionNotificationFetcher = () => {
  return Client.get(commissionNotification())
}

export const loactionNotificationFetcher = (data: any) => {
  return Client.put(loactionNotification(), data)
}

export const batchesFetcher = ({ queryKey }: any) => {
  const { cohortId, page, ...rest } = queryKey[1]

  const params = {
    ...rest,
    page: page,
  }
  const userId = JSON.parse(localStorage.getItem('user') || '{}')?.id || ''
  return Client.get(GET_COHORT_BATCHES(cohortId, userId), { params })
}

export const batchesSearchFetcher = async ({ queryKey }: any) => {
  const params = {
    page: 1,
    ...queryKey[1],
  }
  const userId = JSON.parse(localStorage.getItem('user') || '{}')?.id || ''
  return Client.get(GET_SEARCH_BATCHES(userId), { params })
}

export const getBatchLanguageFetcher = async ({ queryKey }: any) => {
  const { batchId } = queryKey[1]

  return Client.get(getBatchLanguage(batchId))
}

export const enrollBatchFetcher = (query: any) => {
  const { batchId } = query

  return Client.get(ENROLL_BATCH(batchId))
}

export const notifyUserFetcher = (data: any) => {
  return Client.post(NOTIFY_USERS, data)
}

export const getComparePlansFetcher = async ({ queryKey }: any) => {
  const { batchId } = queryKey[1]
  const userId = JSON.parse(localStorage.getItem('user') || '{}')?.id || ''
  return await Client.get(getComparePlansUrl(batchId, userId))
}
export const getUpgradeBannerSnoozeFetcher = (data: any) => {
  const { batchId, ...restPayload } = data

  return Client.put(getUpgradeBannerSnoozeUrl(batchId), { ...restPayload })
}

export const getMahapackDemoVideoFetcher = async ({ queryKey }: any) => {
  const { query } = queryKey[1]
  return Client.get(getMahapackDemoVideoUrl, query)
}

export const getBatchPlans = async (
  batchId?: string,
  withPurchase?: boolean
): Promise<any> => {
  return Client.get(
    `/v3/public/batch-service/batch-plans/batch/${batchId}/plans`,
    {
      ...(withPurchase && { params: { withPurchase } }),
    }
  )
}

export const getOrderDetails = ({ queryKey }: any) => {
  const orderId = queryKey[1]
  const userId = localStorage.getItem('BATCH_BUY_USER_ID') || ''
  return Client.get(getOrderDetailsUrl(orderId, userId)).then(
    (res: any) => res?.data?.data
  )
}

export const faqFetcher = ({ queryKey }: any) => {
  const { faqCatId } = queryKey[1]

  const params = { organizationId: process.env.NEXT_PUBLIC_PP_ORG_ID }
  return Client.get(getFaqUrl(faqCatId), {
    params,
  })
}

export const getInvoiceDetail = ({ queryKey }: any) => {
  const orderId = queryKey[1]
  const userId = localStorage.getItem('BATCH_BUY_USER_ID') || ''
  return Client.get(getInvoiceDetailUrl(orderId, userId)).then(
    (res: any) => res?.data
  )
}

//Saathi fetchers
export const vpCenterFetcher = (data: any) => {
  return Client.get(getVpCenterList())
}

export const exportMappingFetcher = (data: any) => {
  return Client.post(uploadMapping(), data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const bulkUploadedStatusFetcher = ({ queryKey }: any) => {
  const { id } = queryKey[1]

  return Client.get(getBulkUploadedStatus(id))
}

export const getDownloadFileLinkFetcher = ({ queryKey }: any) => {
  const { key } = queryKey[1]

  return Client.get(getDownloadFileLink(key))
}

export const manuallyCreateLeadsFetcher = (data: any) => {
  return Client.post(leadDetails(), data)
}

export const acceptedLeadsFetcher = ({ queryKey }: any) => {
  const { startDate, endDate, orgId, type, status } = queryKey[1]
  const params = {
    startDate,
    endDate,
    orgId,
    type,
    status,
  }
  return Client.get(leadsCountDetails(), { params })
}

export const convertedLeadsFetcher = ({ queryKey }: any) => {
  const { startDate, endDate, orgId, type, status } = queryKey[1]
  const params = {
    startDate,
    endDate,
    orgId,
    type,
    status,
  }
  return Client.get(leadsCountDetails(), { params })
}

export const leadDetailsFetcher = ({ queryKey }: any) => {
  const { startDate, endDate, orgId, type, status, page, limit } = queryKey[1]

  const params = {
    startDate,
    endDate,
    orgId,
    type,
    ...(status && { status: status }),
    page,
    limit,
  }

  return Client.get(leadDetails(), { params })
}
export const updatePaymentDetailsFetcher = (data: PaymentPayload) => {
  return Client.put(updatePaymentDetails(), data)
}

export const reviewStatusDetailsFetcher = () => {
  return Client.get(reviewStatusDetails())
}

export const getSaathiAnalyticsFetcher = ({ queryKey }: any) => {
  const { startDate, endDate, orgId, type } = queryKey[1]
  const params = {
    startDate: startDate,
    endDate: endDate,
    orgId: orgId,
    type: type,
  }
  return Client.get(getSaathiAnalytics(), { params })
}

export const taskAlocatorOtpFetcher = () => {
  return Client.get(taskAlocatorOtp())
}
